/**
 * Reports, the Report dialog and appeals (Console v2 §3.3, slice S3).
 * i18n/index.ts spreads this table; the slice adds its own keys here.
 */
import type { Dict } from '../core';

export const moderationV2En: Dict = {
  'rp.reportMessage': 'Report Message',
  'rp.reportUser': 'Report User',
  'rp.reportServer': 'Report Server',
  'rp.report': 'Report',
  'rp.whatsWrong': 'What’s wrong? Pick the closest one.',
  'rp.cat.child_safety': 'Harm to a child',
  'rp.cat.threat_violence': 'Threat or violence',
  'rp.cat.self_harm': 'Self-harm or suicide',
  'rp.cat.private_info': 'Sharing someone’s private information',
  'rp.cat.intimate_images': 'Intimate images without consent',
  'rp.cat.extortion': 'Extortion or blackmail',
  'rp.cat.violent_extremism': 'Violent extremism',
  'rp.cat.harassment': 'Harassment or bullying',
  'rp.cat.hate': 'Hate against a group',
  'rp.cat.sexual_content': 'Sexual content in the wrong place',
  'rp.cat.scam': 'Scam, phishing or selling accounts',
  'rp.cat.impersonation': 'Pretending to be someone',
  'rp.cat.dangerous_goods': 'Drugs, weapons or other dangerous goods',
  'rp.cat.hacked_account': 'Their account was hacked',
  'rp.cat.under_18': 'They’re under 18',
  'rp.cat.spam': 'Spam',
  'rp.cat.copyright': 'Copyright',
  'rp.cat.server_rules': 'Breaks this server’s rules',
  'rp.cat.other': 'Something else',
  'rp.sub.sexual_content_minor': 'Sexual content involving a minor',
  'rp.sub.grooming': 'Grooming or luring',
  'rp.sub.other_child_danger': 'Other danger to a child',
  'rp.sub.threat_to_life': 'A threat to someone’s life or safety',
  'rp.sub.encouraging_violence': 'Encouraging violence',
  'rp.sub.graphic_violence': 'Graphic violence or gore',
  'rp.sub.in_danger_now': 'Someone may be in danger now',
  'rp.sub.encourages_self_harm': 'Content that encourages self-harm',
  'rp.selfHarmHelp':
    'If someone may be in danger right now, please contact local emergency services. You don’t have to handle this alone.',
  'rp.note': 'Anything else we should know? (optional)',
  'rp.notePlaceholder': 'What happened, and when',
  'rp.noteCount': '{n} / {max}',
  'rp.alsoBlock': 'Also block {name}',
  'rp.private': 'The person you report isn’t told who reported them.',
  'rp.send': 'Send report',
  'rp.thanksTitle': 'Report sent',
  'rp.thanks': 'Thanks for telling us. Our Safety team will review it.',
  'rp.blocked': 'You blocked {name}.',
  'rp.attachmentsOnly': { one: '{n} attachment', other: '{n} attachments' },
  'rp.tooMany': 'You’ve sent a lot of reports in the last hour. Try again a little later.',

  'ap.appeal': 'Appeal',
  'ap.askReview': 'Ask us to review this',
  'ap.title': 'Ask us to review this',
  'ap.intro.warning': 'Tell us why you think this warning was a mistake.',
  'ap.intro.limit': 'Tell us why you think this limit on your account was a mistake.',
  'ap.intro.suspension': 'Tell us why you think this suspension was a mistake.',
  'ap.statement': 'Your side',
  'ap.who': 'Someone who didn’t take the action reviews it. You can ask once.',
  'ap.send': 'Send',
  'ap.sentTitle': 'We got it',
  'ap.sent': 'Thanks. We’ll review it and let you know what we decided.',
  'ap.outcomeTitle': 'We reviewed your appeal',
  'ap.outcome.upheld': 'We looked again and kept our decision.',
  'ap.outcome.reduced': 'We shortened it.',
  'ap.outcome.reversed': 'We reversed it. Sorry about that.',
  'ns.err.100051': 'You already asked us to review this.',
  'ns.err.100052': 'This can no longer be appealed.',
};
